<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div :class="checkWidth() + ' ' + 'container'">
        <CRow>
          <CCol col="12">
            <div
              class="background-image"
              v-bind:style="`background-image:url(https://mdl.mfu.ac.th/${message.media[0].url})`"
            >
              <div v-if="show">
                <div class="position">
                  <div class="card">
                    <div class="block">
                      <h1>MISSION COMPLETE!</h1>
                      <div
                        class="button button-next"
                        @click="commitUserProgress"
                      >
                        <div col="12">
                          <div style="font-size: 18px">NEXT</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="image_size" v-else>
                <div class="image_person">
                  <img
                    :src="'https://mdl.mfu.ac.th' + message.media[1].url"
                    class="image"
                    style="object-fit: contain"
                  />
                </div>
                <div class="image_person">
                  <img
                    :src="'https://mdl.mfu.ac.th' + message.media[2].url"
                    class="image"
                    style="object-fit: contain"
                  />
                </div>
                <div class="card_message">
                  <CardMessage
                    :index="index_display_message"
                    :message="message.message"
                    :showModal="true"
                    :profile_image="message.media[3].url"
                    :lang="language"
                    @returnIndex="next"
                  />
                </div>
              </div>
            </div>
          </CCol>
        </CRow>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CardMessage from '@/components/elements/Card/CardMessage';
import LoadingMDL from '@/components/loading/LoadingMDL';
import '../../../assets/scss/chinessStyle2.scss';

export default {
  name: 'CMD01',
  components: {
    CardMessage,
    LoadingMDL,
  },
  props: {},
  data() {
    return {
      message: [],
      language: '',
      loading: true,
      navigate: '',
      content: [],
      index_display_message: 0,
      CheckWidth: window.innerWidth.toString(),
      condition: [],
      startTime: '',
      criteria_id: '',
      topic: {},
      // code: "605418cb883ae722ba1b0c5f",
      code: '',
      section: '',
      chapter: null,
      show: false,
      v3Data: null,
    };
  },
  methods: {
    onLoadData() {
      this.loading = true;
      this.language = this.$store.getters['language/getLanguage'];
      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },
    next: function (index) {
      if (index == this.content.length - 1) {
        //stamp
        const data = [
          {
            codeItem: this.v3Data.codeItem,
            courseId: this.$store.state.necessary.learningCourse,
            template: this.v3Data.templateID,
            section: this.$store.state.v3.v3EnrollData.data.section,
            content: this.v3Data.content,
            type: this.v3Data.type,
            answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
            progress: 100,
            score: 0,
            maxScore: 0,
          },
        ];

        var str = this.navigate.split('-');
        if (str[0] == 'LS01') {
          this.$store.dispatch('v3/saveContent', data);
          this.show = true;

          const path = `/v3/${str[0]}/${str[1]}`;
          return this.$router.push(path);
        } else {
          this.$store.dispatch('v3/saveContent', data);

          const nextPath = `/v3/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }

        // // ส่วนนี้เป็นส่วนของการบันทึกข้อมูลไปยัง DB โดยส่งข้อมูลไปยัง backend ในรูปแบบนี้โดยไม่ต้องรอค่ารีเทิร์น

        // //===========================================================

        //next path

        // this.commitUserProgress();
      } else {
        this.index_display_message = index + 1;
        this.message = this.content[index + 1];
      }
    },

    commitUserProgress: function () {
      this.loading = true;
      // this.$store.dispatch('template/commitUserProgressChinese2', {
      //   code: this.code,
      //   contentId: this.criteria_id,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   topic: this.topic,
      //   chapter: this.chapter,
      //   condition: this.condition,
      // });
    },
    checkWidth() {
      if (this.CheckWidth > 500) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 500) {
        return 'container-chinese-card-mobile';
      }
    },
    resetLocalState() {
      this.index_display_message = 0;
      this.message = [];
    },
  },
  computed: {
    ...mapGetters({
      // getTemplateAndProgress: 'template/getTemplateAndProgress',
      // getResponseStatus: 'template/getResponseStatus',
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template.content.item;
      this.message = template.content.item[0];
      this.navigate = template.navigate.next.action;

      this.loading = false;
    },
    '$route.params.id'() {
      //use to watch param id if changes
      //clear old state and Load new data
      this.loading = true;

      this.resetLocalState();
      this.onLoadData();
    },

    // getTemplateAndProgress: function (value) {
    //   if (value.criteria.condition.criteriaType.length != 0) {
    //     this.condition.push({
    //       criteria: value.criteria.condition.criteriaType[0]._id,
    //       val: value.criteria.condition.criteriaType[0].val,
    //     });
    //   }
    //   this.criteria_id = value.criteria._id;
    //   this.chapter = value.chapter;
    //   this.topic = value.topicPosition;

    //   this.content = value.templateData.content.item;
    //   this.message = value.templateData.content.item[0];
    //   this.navigate = value.templateData.navigate.next.action;
    //   this.loading = false;
    // },
    // getResponseStatus: function (value) {
    //   console.log('start');
    //   if (value.status == 200) {
    //     if (this.navigate != '') {
    //       var str = this.navigate.split('-');
    //       let body = '/' + str[0] + '/' + str[1];
    //       if (str[0] == this.$route.name) {
    //         console.log('xxxxxx');

    //         this.index_display_message = 0;
    //         this.message = [];
    //         let payload = {
    //           templateCode: this.navigate,
    //           code: this.code,
    //           section: this.section,
    //           // section: "testing",
    //         };
    //         // this.$store.dispatch('template/fetchTemplateAndProgress', payload);
    //         this.$router.push(body);
    //       }

    //       this.$router.push(body);
    //     }
    //   }
    // },
    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {},
  mounted() {
    this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.position {
  display: flex;
  justify-content: center;
  align-items: center;
}
.card {
  width: 700px;
  height: 300px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.block {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.button {
  width: 145px;
  height: 43px;
  margin-bottom: 0;
  background-color: #1d5bd7;
  color: white;
  font-size: 12px;
  border-radius: 8px !important;
  cursor: pointer;
  margin-top: 10%;
}
.image_size {
  width: 100%;
  height: 70vh;
  display: flex;
}
.container {
  min-width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  z-index: 1;
  overflow-x: hidden;
  position: relative;
}
div.min-vh-100 {
  z-index: -99;
}
.background-image {
  width: 100%;
  // justify-content: center;
  height: 100vh;
  padding: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image {
  height: 100%;
  width: 50%;
}
.image_person {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}
.card_message {
  position: absolute;
  display: flex;
  margin: 0 auto;
  left: 0;
  right: 0;
  justify-content: center;
  width: 80%;
  z-index: 1;
  bottom: 10%;
}

// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .image {
    height: 100%;
    width: 50%;
    object-fit: contain;
  }
  .image_person {
    margin-top: 20%;
    display: flex;
    justify-content: space-between;
    height: 50%;
    align-items: center;
  }
  .card_message {
    width: 80%;
    height: 45%;
  }
  .body_message {
    font-size: 24px;
  }
  .card {
    width: 290px;
    height: 200px;
  }
  h1 {
    font-size: 27px;
  }
}
// resolution ipad
@media only screen and (min-width: 600px) and (max-width: 1023px) {
  .image_person {
    margin-top: 5%;
    display: flex;
    justify-content: space-between;
  }
}
// resolution ipad pro
@media only screen and (min-width: 1024px) and (max-width: 1365px) and (min-height: 1024px) and (max-height: 1367px) {
  .image_person {
    height: 100%;
  }
  .image {
    height: 90%;
    width: 50%;
  }
  .card_message {
    bottom: 30%;
  }
  .position {
    margin-top: -50%;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1367px) {
}
@media only screen and (max-height: 768px) and (max-width: 1024px) {
}
</style>
